import { render, staticRenderFns } from "./eleInvoice.vue?vue&type=template&id=0dbff421&scoped=true"
import script from "./eleInvoice.vue?vue&type=script&lang=js"
export * from "./eleInvoice.vue?vue&type=script&lang=js"
import style0 from "./eleInvoice.vue?vue&type=style&index=0&id=0dbff421&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbff421",
  null
  
)

export default component.exports